<template>
    <div v-if="post.operation === 'stage'">
        <div v-for="detail in post.details" :key="detail.id">
            <div v-if="detail.field == 'event_id'">
                <div>
                    <span v-if="detail.from != null" class="mr-2">
                        <strong>{{ $t('feed.from') }}:</strong>
                        <span class="ml-1">{{ detail.from }}</span>
                    </span>
                    <span class="field mr-1">{{ $t('feed.to') }}:</span>
                    <span>{{ detail.to }}</span>
                </div>
            </div>
            <div v-else>
                <div v-if="detail.from == 0">
                    <span>{{ $t(`feed.fields.${detail.field}`) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PostContentStage',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>
.field {
    font-weight: 500;
}
</style>
